import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
let AuthLinkDeleteDialog = class AuthLinkDeleteDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "toggleDialog", void 0);
    _defineProperty(this, "visible", false);
  }
  onDialogClose() {
    this.visible = false;
    this.$emit("dialogClose");
  }
  onDeleteConfirm() {
    this.visible = false;
    this.$emit("deleteConfirm");
  }
};
__decorate([Prop({
  default: false
})], AuthLinkDeleteDialog.prototype, "toggleDialog", void 0);
AuthLinkDeleteDialog = __decorate([Options({
  watch: {
    toggleDialog() {
      this.visible = this.toggleDialog;
    }
  }
})], AuthLinkDeleteDialog);
export default AuthLinkDeleteDialog;